import React, { useContext, useEffect } from 'react';
import { observer } from 'mobx-react';
import { AppContextProvider } from '../../AppLoader';
import { GradientDivider } from './GradientDivider';
import WixAppDevice from '../../../assets/images/wixAppDevice.svg';

/**
 * Body of the redesigned "Success" step — the Wix-app device illustration (per the
 * wix-2025 Figma). On mount it enables the owner-app method and refreshes the 2FA
 * settings (same as the old `SuccessfulStep`).
 */
export const SuccessBody: React.FC = observer(() => {
  const {
    rootStore: {
      postLoginStore: {
        premiumUsers2FaEnforcementStore: { ownerAppStore: store },
      },
    },
  } = useContext(AppContextProvider);
  useEffect(() => {
    store.enable();
    store.premiumUsers2FaEnforcementStore.fetchTwoFASettings();
  }, [store]);
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        width: '100%',
      }}
    >
      <div style={{ overflow: 'hidden', height: 200, width: '100%' }}>
        <WixAppDevice
          width={275}
          style={{ display: 'block', margin: '0 auto' }}
        />
      </div>
      <GradientDivider />
    </div>
  );
});
